import { Component, ElementRef, OnInit, SecurityContext } from '@angular/core';
import { UtilityService } from '@app/shared/services/utility/utility.service';
import { ApplicantComponent } from './applicant/applicant.component';
import { ApplicationFormComponent } from './application-form/application-form.component';
import { JointApplicantComponent } from './joint-applicant/joint-applicant.component';
import { ResidentsComponent } from './residents/residents.component';
import { AffordabilityComponent } from './affordability/affordability.component';
import { SafeguardingComponent } from './safeguarding/safeguarding.component';
import { ReferencesComponent } from './references/references.component';
import { JointApplicantReferencesComponent } from './joint-applicant-references/joint-applicant-references.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { DomSanitizer } from '@angular/platform-browser';
import { SlideCommonService } from './common/slide-common.service';

@Component({
    selector: 'app-application',
    templateUrl: './application.component.html',
    providers: [
        UtilityService
    ],
    imports: [
        ApplicationFormComponent,
        ApplicantComponent,
        JointApplicantComponent,
        ResidentsComponent,
        AffordabilityComponent,
        SafeguardingComponent,
        ReferencesComponent,
        JointApplicantReferencesComponent,
        TermsAndConditionsComponent
    ]
})
export class ApplicationComponent implements OnInit {
    termsAndConditionsPageHeading = "";
    termsAndConditionsBodyText = "";

    constructor(
        private utilityService: UtilityService,
        private el: ElementRef,
        private domSanitizer: DomSanitizer,
        private slideCommonService: SlideCommonService
    ) { }

    isNullOrWhiteSpace(string: string): boolean {
        return this.utilityService.isNullOrWhiteSpace(string);
    }

    ngOnInit(): void {
        const cpt = this.el.nativeElement;
        this.termsAndConditionsPageHeading = cpt.getAttribute("termsAndConditionsPageHeading");

        this.termsAndConditionsBodyText = this.domSanitizer.sanitize(SecurityContext.HTML, cpt.getAttribute("termsAndConditionsBodyText")) || "";

        this.slideCommonService.setRef(this.el);
    }
}
